<div class="header" [class]="colour">
  <ng-container *ngFor="let step of steps; let i = index; let last = last">
    <div class="step" [class.active]="i === selectedIndex" [class.complete]="step.complete">
      <div class="step-circle">
        <ng-container *ngIf="!step.complete; else stepComplete">
          {{ i + 1 }}
        </ng-container>
        <ng-template #stepComplete>
          <mat-icon svgIcon="check"></mat-icon>
        </ng-template>
      </div>
    </div>
    <div class="step-between" [class.complete]="step.complete" [class.last]="last">
      <span class="step-label" [class.complete]="step.complete" *ngIf="step.label">
        <ng-container *ngIf="step._labelContent; else textLabel">
          <ng-container [ngTemplateOutlet]="step._labelContent"></ng-container>
        </ng-container>
        <ng-template #textLabel>
          {{ step.label }}
        </ng-template>
      </span>
      <span class="step-line" [class.complete]="step.complete" [class.hide]="last"></span>
    </div>
  </ng-container>
</div>
